import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html } from "lit/static-html.js";
import EkoElement from "@/utilities/element";
import style from "./container.css?inline";

@customElement("eko-container")
class Container extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) centered = false;
  @property({ reflect: true }) size?: "sm" | "md" | "lg" | "xl";

  render() {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-container": Container;
  }
}

export default Container;
